import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {useState} from 'react';
import {AccountToken} from '../__generated__/resolvers-types';

const LIST_ACCOUNT_TOKEN = gql`
  query Query {
    listAccountTokens {
      id
      name
      photoURL
      provider
      shopId
      userId
    }
  }
`;

/**
 * Account detail for etsy
 */
export type HookAccountToken = Pick<AccountToken, 'id' | 'name' | 'provider' | 'photoURL' | 'shopId' | 'userId'>;

export default function useGetAllAccountToken() {
  const {data, refetch, loading} = useQuery<{listAccountTokens: HookAccountToken[]}>(LIST_ACCOUNT_TOKEN);
  const [selectedAccount, setSelectedAccount] = useState<HookAccountToken | undefined>();

  return {
    accounts: data && data.listAccountTokens ? data.listAccountTokens : [],
    refetchAccounts: refetch,
    selectedAccount,
    setSelectedAccount,
    loading,
  };
}
